import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  effect,
  inject,
  Input,
  input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ProductInterface,
  ProviderProductInterface,
  VariantItemInterface,
} from '../../../../core/interfaces/product/product';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { InputSwitchModule } from 'primeng/inputswitch';
import {
  CurrencyEnum,
  CurrencyPipe,
  PercentageTypeEnum,
  priceSourceConst,
  PriceSourceEnum,
  providerProductIncrementTypeConst,
  ProviderProductIncrementTypeEnum,
  providerSettingsInterface,
  VariantIncrementTypeEnum,
  variantItemIncrementType,
  VariantItemPriceTypeEnum,
} from '@component-library';
import { DividerModule } from 'primeng/divider';
import { StoreInterface } from '../../../../core/interfaces/store/store-interface';
import { TuiMoneyModule } from '@taiga-ui/addon-commerce';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProviderProductFindVariantItemPipe } from '../pipes/provider-product-find-variant-item.pipe';
import { ProviderProductClass } from '../../../../core/classes/provider-product/provider-product';
import { ProductClass } from '../../../../core/classes/product/product';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { PriceTemplateInterface } from '../../../../core/interfaces/price-template/price-template';
import { AddUpdatePriceTemplateComponent } from '../../../price/add-price-template/add-update-price-template.component';
import { StoreService } from '../../../../core/store/store.service';
import { TableModule } from 'primeng/table';
import { InputGroupModule } from 'primeng/inputgroup';
import { TooltipModule } from 'primeng/tooltip';

import { MessagesModule } from 'primeng/messages';
import { VariantItemIncrementTypePipe } from '../../../../../../../../libraries/component-library/src/lib/core/pipe/variant-item-increment-type.pipe';
import { CurrencyAmountPipe } from '../../../../core/pipes/currency-amount.pipe';
import { Select } from 'primeng/select';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { RedisProviderCategoryAttributeRootInterface } from '../../../../core/interfaces/categories/provider-category-attributes-interface';
import { Message } from 'primeng/message';

@Component({
  selector: 'magenty-provider-product-detail-base',
  imports: [
    CommonModule,
    InputTextModule,
    FormsModule,
    InputSwitchModule,
    DividerModule,
    CurrencyPipe,
    TuiMoneyModule,
    ButtonModule,
    InputNumberModule,
    ProviderProductFindVariantItemPipe,
    TableModule,
    InputGroupModule,
    TooltipModule,
    MessagesModule,
    VariantItemIncrementTypePipe,
    CurrencyAmountPipe,
    Select,
    ToggleSwitch,
    Message,
  ],
  templateUrl: './provider-product-detail-base.component.html',
  styleUrl: './provider-product-detail-base.component.scss',
})
export class ProviderProductDetailBaseComponent
  implements OnChanges, AfterViewInit
{
  changeDetectorRef = inject(ChangeDetectorRef);
  dialogService = inject(DialogService);
  storeService = inject(StoreService);

  @Input() product: ProductInterface = new ProductClass(
    this.storeService.store$()
  );
  @Input() providerProduct: ProviderProductInterface = new ProviderProductClass(
    this.storeService.store$()
  );
  @Input() providerSettings: providerSettingsInterface | undefined;
  store: StoreInterface | undefined | null;
  priceSourceOptions = priceSourceConst;
  providerProductIncrementTypeOptions = providerProductIncrementTypeConst;
  priceTemplateOptions: {
    header: string;
    field: string;
    providerId: string;
  }[] = [];
  validationSetTimeId: any;
  ref = inject(DynamicDialogRef);
  addPriceTemplateComponentRef: DynamicDialogRef | undefined;
  isVariantTable = false;

  productVariantList: VariantItemInterface[] = [];
  messages: MessagesModule[] = [];
  currencyRate = 1;
  providerCategoryAttributes = input<
    RedisProviderCategoryAttributeRootInterface[]
  >([]);

  constructor() {
    this.store = this.storeService.store$();
    effect(() => {
      this.store = this.storeService.store$();
      this.getPriceTemplate();

      this.currencyRate =
        this.storeService
          .store$()
          .panelSettings.base?.PriceSettings.Currencies.find(
            (f) => f.Type === this.providerProduct.Currency
          )?.Amount ?? 1;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.getPriceTemplate();

    /*
    this.providerProduct.getVariantList().map(variant=>{
      const found=this.product.VariantItems.find(f=>f.Code===variant.VariantItemCode)

      if(found){
        this.productVariantList.push(found)
      }
    })
*/
    this.currencyRate =
      this.storeService
        .store$()
        .panelSettings.base?.PriceSettings.Currencies.find(
          (f) => f.Type === this.product.Price.Currency
        )?.Amount ?? 1;

    this.productVariantList = this.providerProduct.getProductVariantList();

    this.isVariantTable =
      (this.product.IsVariant &&
        this.product.VariantItemPriceType ===
          VariantItemPriceTypeEnum.PriceDifference) ??
      false;
  }

  getPriceTemplate = () => {
    this.priceTemplateOptions =
      this.storeService
        .store$()
        ?.priceTemplate.priceTemplateField.filter(
          (f) => f.providerId === this.providerProduct.ProviderId
        ) ?? [];

    if (this.priceTemplateOptions.length === 1) {
      this.providerProduct.PriceTemplateId = this.priceTemplateOptions[0].field;
    }

    this.validation();
  };

  sellPriceClear = () => {
    this.providerProduct.SellPriceChangeValue = 0;
    this.providerProduct.SellPriceChangeIsPercent = PercentageTypeEnum.No;
    this.providerProduct.SellIncreaseDecreaseType =
      ProviderProductIncrementTypeEnum.Up;
    this.validation();
  };
  strikeThroughPriceClear = () => {
    this.providerProduct.StrikeThroughPriceChangeValue = 0;
    this.providerProduct.StrikeThroughPriceChangeIsPercent =
      PercentageTypeEnum.No;
    this.providerProduct.StrikeThroughIncreaseDecreaseType =
      ProviderProductIncrementTypeEnum.Up;
    this.validation();
  };

  ngAfterViewInit() {
    this.providerProduct.UseProductName = this.product.Name.length > 0;
    this.changeDetectorRef.detectChanges();
  }

  nameChange = (event: string) => {
    this.providerProduct.Name = event;
  };

  validation = () => {
    clearTimeout(this.validationSetTimeId);
    this.validationSetTimeId = setTimeout(() => {
      this.providerProduct.validationFunction(
        this.providerCategoryAttributes()
      );
    }, 100);
  };

  addAndUpdatePriceTemplateOpenModal = (
    priceTemplate: PriceTemplateInterface | undefined
  ) => {
    this.addPriceTemplateComponentRef = this.dialogService.open(
      AddUpdatePriceTemplateComponent,
      {
        header: `Fiyat Şablonu Ekle`,
        width: '60vw',
        modal: true,
        closable: true,
        data: {
          priceTemplate: priceTemplate,
          providerId: this.providerProduct.ProviderId,
          marketplaceIdentity: this.providerProduct.MarketplaceIdentity,
        },
        breakpoints: {
          '960px': '70vw',
          '640px': '90vw',
        },
      }
    );
  };

  protected readonly priceSourceConst = priceSourceConst;
  protected readonly PriceSourceEnum = PriceSourceEnum;
  protected readonly PercentageTypeEnum = PercentageTypeEnum;
  protected readonly ProviderProductIncrementTypeEnum =
    ProviderProductIncrementTypeEnum;
  protected readonly VariantItemPriceTypeEnum = VariantItemPriceTypeEnum;
  protected readonly variantItemIncrementType = variantItemIncrementType;
  protected readonly VariantIncrementTypeEnum = VariantIncrementTypeEnum;
  protected readonly name = name;
  protected readonly incrementType = variantItemIncrementType;
  protected readonly CurrencyEnum = CurrencyEnum;
}
